export default {
  text: 'Este restaurante está suspendido. Póngase en contacto con su persona de contacto o escríbanos a <a>{{supportEmail}}</a> si desea restaurarlo',
};
